export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1580014317999-e9f1936787a5?crop=entropy&cs=srgb&fm=jpg&q=85",
  reparation: "/images/reparation.jpg",
  entretien: "/images/entretien.jpg",
  diagnostic: "/images/diagnostic.jpg",
  garage: "/images/garage.jpg",
  atelier: "/images/atelier.jpg",
  pneus: "https://images.unsplash.com/photo-1645445522156-9ac06bc7a767?crop=entropy&cs=srgb&fm=jpg&q=85",
  occasions:
    "https://images.unsplash.com/photo-1533558701576-23c65e0272fb?crop=entropy&cs=srgb&fm=jpg&q=85",
  depotVente:
    "https://images.unsplash.com/photo-1596639410348-8470f7fa9f84?crop=entropy&cs=srgb&fm=jpg&q=85",
};
